/** Auth0 authenticator Packages. */
import { useAuth0 } from '@auth0/auth0-react';

/**
 * Custom hook to extract user role from Auth0 user object.
 * @returns {Array} Array of roles, or an empty array if user is not loaded.
 */
const useUserRole = () => {
    const { user } = useAuth0();
    return user?.['https://drayage.insightshipping.io/roles'] || [];
};

export default useUserRole;
